/**
 * Reverses the key-value pairs of an enum-like object and returns the result as a new object.
 * @template TINPUT - The type of the enum-like object.
 * @param {TINPUT} enumObj - The enum-like object to be reversed.
 * @returns {Record<string, string>} - The object with reversed key-value pairs.
 * @throws {Error} - If the input enum object is null, undefined, contains non-string values, or has duplicate values.
 */
export function reverseMapEnum(enumObj) {
    if (enumObj == null) {
        throw new Error('Invalid input. The enum object cannot be null or undefined.');
    }
    const seenValues = new Set();
    const reverseReducer = (reversedEnum, key) => {
        const value = enumObj[key];
        if (typeof value !== 'string') {
            throw new Error(`Invalid enum value for key '${key}'. Expected string, got '${typeof value}'.`);
        }
        if (seenValues.has(value)) {
            throw new Error(`Duplicate enum value '${value}' found for keys.`);
        }
        seenValues.add(value);
        reversedEnum[value] = key;
        return reversedEnum;
    };
    return Object.keys(enumObj).reduce(reverseReducer, {});
}
//# sourceMappingURL=TypeConversions.js.map